// Fachada do domínio History — métodos da instância (ver core.ts).
import { historyService } from './core';
import { HISTORY_TYPE_META, getHistoryTypeMeta } from '@modules/history';

// ─── Operações com dados (via adapter) ──────────────────────────
export const listHistoryByLead = historyService.listHistoryByLead;
export const addHistoryNote    = historyService.addHistoryNote;

// ─── Funções puras (reexportadas do módulo) ─────────────────────
export { HISTORY_TYPE_META, getHistoryTypeMeta };

// ─── Tipos ──────────────────────────────────────────────────────
export type { AddHistoryNoteParams } from '@modules/history';
